
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "es",
  "fr",
  "he",
  "it",
  "pl",
  "pt",
  "ca",
  "ko",
  "zh",
  "bs",
  "uk-UA"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_661b6c44",
      load: () => import("#nuxt-i18n/661b6c44" /* webpackChunkName: "locale_en_46json_661b6c44" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_c1b667a7",
      load: () => import("#nuxt-i18n/c1b667a7" /* webpackChunkName: "locale_de_46json_c1b667a7" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_68355a63",
      load: () => import("#nuxt-i18n/68355a63" /* webpackChunkName: "locale_es_46json_68355a63" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_3dca996b",
      load: () => import("#nuxt-i18n/3dca996b" /* webpackChunkName: "locale_fr_46json_3dca996b" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_1c862fe9",
      load: () => import("#nuxt-i18n/1c862fe9" /* webpackChunkName: "locale_he_46json_1c862fe9" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8d0a32ba",
      load: () => import("#nuxt-i18n/8d0a32ba" /* webpackChunkName: "locale_it_46json_8d0a32ba" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_19905b2b",
      load: () => import("#nuxt-i18n/19905b2b" /* webpackChunkName: "locale_pl_46json_19905b2b" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_5b46922f",
      load: () => import("#nuxt-i18n/5b46922f" /* webpackChunkName: "locale_pt_46json_5b46922f" */),
      cache: true
    }
  ],
  ca: [
    {
      key: "locale_ca_46json_2fba9222",
      load: () => import("#nuxt-i18n/2fba9222" /* webpackChunkName: "locale_ca_46json_2fba9222" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_f1656fde",
      load: () => import("#nuxt-i18n/f1656fde" /* webpackChunkName: "locale_ko_46json_f1656fde" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_a7c9d31b",
      load: () => import("#nuxt-i18n/a7c9d31b" /* webpackChunkName: "locale_zh_46json_a7c9d31b" */),
      cache: true
    }
  ],
  bs: [
    {
      key: "locale_bs_46json_33735734",
      load: () => import("#nuxt-i18n/33735734" /* webpackChunkName: "locale_bs_46json_33735734" */),
      cache: true
    }
  ],
  "uk-UA": [
    {
      key: "locale_uk_45UA_46json_1cdcd306",
      load: () => import("#nuxt-i18n/1cdcd306" /* webpackChunkName: "locale_uk_45UA_46json_1cdcd306" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/en.json"
      ],
      language: "en",
      dir: "ltr"
    },
    {
      code: "de",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/de.json"
      ],
      language: "de",
      dir: "ltr"
    },
    {
      code: "es",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/es.json"
      ],
      language: "es",
      dir: "ltr"
    },
    {
      code: "fr",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/fr.json"
      ],
      language: "fr",
      dir: "ltr"
    },
    {
      code: "he",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/he.json"
      ],
      language: "he",
      dir: "rtl"
    },
    {
      code: "it",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/it.json"
      ],
      language: "it",
      dir: "ltr"
    },
    {
      code: "pl",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/pl.json"
      ],
      language: "pl",
      dir: "ltr"
    },
    {
      code: "pt",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/pt.json"
      ],
      language: "pt",
      dir: "ltr"
    },
    {
      code: "ca",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/ca.json"
      ],
      language: "ca",
      dir: "ltr"
    },
    {
      code: "ko",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/ko.json"
      ],
      language: "ko",
      dir: "rtl"
    },
    {
      code: "zh",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/zh.json"
      ],
      language: "zh",
      dir: "ltr"
    },
    {
      code: "bs",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/bs.json"
      ],
      language: "bs",
      dir: "ltr"
    },
    {
      code: "uk-UA",
      files: [
        "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/uk-UA.json"
      ],
      language: "uk-UA",
      dir: "ltr"
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/en.json",
        cache: undefined
      }
    ],
    language: "en",
    dir: "ltr"
  },
  {
    code: "de",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/de.json",
        cache: undefined
      }
    ],
    language: "de",
    dir: "ltr"
  },
  {
    code: "es",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/es.json",
        cache: undefined
      }
    ],
    language: "es",
    dir: "ltr"
  },
  {
    code: "fr",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/fr.json",
        cache: undefined
      }
    ],
    language: "fr",
    dir: "ltr"
  },
  {
    code: "he",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/he.json",
        cache: undefined
      }
    ],
    language: "he",
    dir: "rtl"
  },
  {
    code: "it",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/it.json",
        cache: undefined
      }
    ],
    language: "it",
    dir: "ltr"
  },
  {
    code: "pl",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/pl.json",
        cache: undefined
      }
    ],
    language: "pl",
    dir: "ltr"
  },
  {
    code: "pt",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/pt.json",
        cache: undefined
      }
    ],
    language: "pt",
    dir: "ltr"
  },
  {
    code: "ca",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/ca.json",
        cache: undefined
      }
    ],
    language: "ca",
    dir: "ltr"
  },
  {
    code: "ko",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/ko.json",
        cache: undefined
      }
    ],
    language: "ko",
    dir: "rtl"
  },
  {
    code: "zh",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/zh.json",
        cache: undefined
      }
    ],
    language: "zh",
    dir: "ltr"
  },
  {
    code: "bs",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/bs.json",
        cache: undefined
      }
    ],
    language: "bs",
    dir: "ltr"
  },
  {
    code: "uk-UA",
    files: [
      {
        path: "/home/runner/work/ott-web-portal2/ott-web-portal2/i18n/locales/uk-UA.json",
        cache: undefined
      }
    ],
    language: "uk-UA",
    dir: "ltr"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/